export default "__VITE_ASSET__b7fb005e__"